module.exports = __webpack_public_path__ + "img/29-s.f90eaac3.png";